export enum STATUS {
  Online = "Online",
  Offline = "Offline",
  ConectWhatsapp = "ConectWhatsapp",
  OpenAgent = "OpenAgent",
}
